





















import { Component, Prop, Vue } from "vue-property-decorator";
import mhlogo from "../assets/mh-logo.svg";
import { TransactionPlan } from "../store/user";
import Getter from "../store/getters";

@Component
export default class TransactionPlans extends Vue {
  @Prop() transaction_plans!: Array<TransactionPlan>;
  // private transactions: Array<Transaction> = [];
  private fields = [
    { key: "planname", label: "Plan # - Plan Description", stickyColumn: true },
    {
      key: "average_daily_balance",
      label: "Balance Subject to Interest Rate",
      transform: this.format_dollars
    },
    {
      key: "monthly_rate",
      label: "Monthly Periodic Rate",
      transform: this.format_percent
    },
    {
      key: "base_rate",
      label: "Annual Percentage Rate",
      transform: this.format_percent
    },
    {
      key: "finance_charge",
      label: "Interest Charge",
      transform: this.format_dollars
    },
    {
      key: "min_payment",
      label: "Minimum Payment",
      transform: this.format_dollars
    }
  ];
  format_dollars(value: number, negative: boolean) {
    let val = (value / 1).toFixed(2);
    val = `$${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    if (negative) val = "-" + val;
    return val;
  }
  format_percent(value: number, negative: boolean) {
    let val = (value / 1).toFixed(2);
    val = `${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%`;
    if (negative) val = "-" + val;
    return val;
  }
}
